<template>
  <div class="flex w-full h-full flex-wrap items-stretch justify-between">
    <div class="w-full mx-auto">
      <ReportTotal :total="total" class="mb-6" />
      <div class="flex flex-col items-start">
        <div class="flex flex-col sm:flex-row relative w-full mb-6 space-x-2" style="height: 26rem">
          <div class="flex flex-col space-y-2 w-full lg:max-w-lg">
            <base-select
              v-if="$store.getters['companies/list'].length > 1"
              v-model="company"
              :options="$store.getters['companies/list']"
              :optionType="{id: 'id', label: 'name', extra: ['area', 'customer_account']}"
              :placeholder="$t(`mygwf.components.Select.choose_company`)"
              @onSelect="selectedMeter = {}"
              bg="white"
              searchable
              allowClear
            />
            <ReportMeters
              :fetching="fetching"
              :meters="meters"
              v-model="selectedMeter"
              @refresh="fetchReadouts"
            />
          </div>
          <base-map
            ref="map"
            class="hidden sm:flex"
            v-model="selectedMeter"
            :groups="[{list: meters, label: 'meter'}]"
            :startPopulating="startPopulating"
          />
          <!-- <ReportPane /> -->
        </div>
        <div class="flex bg-white shadow w-full items-stretch stretch_md_min_h">
          <ReportBanner v-if="!isMeterSelected" />
          <div v-else class="flex flex-col lg:flex-row w-full">
            <ReportState :meter="selectedMeter" />
            <ReportChart :meter="selectedMeter" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseMap, BaseSelect} from '@/components/base'
import isEmpty from 'lodash-es/isEmpty'
import ReportTotal from './ReportTotal.vue'
import ReportMeters from './ReportMeters.vue'
import ReportState from './ReportState.vue'
import ReportChart from './ReportChart.vue'
import ReportBanner from './ReportBanner.vue'
import ReportPane from './ReportPane.vue'

export default {
  mounted() {
    //this.company = Array.from(this.$route.query.type || []).map(v => parseInt(v, 10))
    this.company = this.$route.query.company ? parseInt(this.$route.query.company, 10) : undefined
  },
  data() {
    return {
      fetching: false,
      detailsFetching: false,
      company: undefined,
      total: {
        meters: 0,
        volume: 0,
        alerts: 0,
        readouts: 0,
      },
      meters: [],
      selectedMeter: {},
      startPopulating: false,
    }
  },
  methods: {
    fetchReadouts() {
      this.fetching = true
      this.$store
        .dispatch('reports/getTotal')
        .then(data => (this.total = data))
        .catch(err => {})
      this.startPopulating = false
      this.$store
        .dispatch('reports/getMeasurements')
        .then(data => {
          const newData = data.map(item => {
            const alerts = Object.values(item.state).filter(i => typeof i === 'boolean' && i)
            item.state = {...item.state, alertCount: alerts.length}
            return item
          })
          //
          this.meters = newData
        })
        .then(() => (this.startPopulating = true))
        .catch(err => {})
        .finally(() => (this.fetching = false))
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(n, o) {
        this.fetchReadouts()
      },
    },
    company(n, o) {
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
  },
  computed: {
    isMeterSelected() {
      return !isEmpty(this.selectedMeter)
    },
  },
  components: {
    BaseMap,
    BaseSelect,
    ReportTotal,
    ReportMeters,
    ReportState,
    ReportChart,
    ReportBanner,
    ReportPane,
  },
}
</script>

<style scoped>
.stretch_md_min_h {
  min-height: 30rem;
}
</style>
